module.exports = __webpack_public_path__ + "eb9669f04e7477ad223af9478b593ec4.png";